"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const inertia_1 = require("@inertiajs/inertia");
const inertia_react_1 = require("@inertiajs/inertia-react");
const react_1 = __importDefault(require("react"));
const ziggy_js_1 = __importDefault(require("ziggy-js"));
const Layout_1 = __importDefault(require("../Layout/Layout"));
const DeleteButton_1 = __importDefault(require("../Shared/DeleteButton"));
const FlashMessages_1 = __importDefault(require("../Shared/FlashMessages"));
const LoadingButton_1 = __importDefault(require("../Shared/LoadingButton"));
const SelectInput_1 = __importDefault(require("../Shared/SelectInput"));
const TextInput_1 = __importDefault(require("../Shared/TextInput"));
const Edit = () => {
    const { imageModel } = (0, inertia_react_1.usePage)().props;
    const categorys = [
        { type: "GLOBAL", name: "Général" },
        { type: "HEALTH", name: "Santé et nutrition" },
        { type: "EDUCAT", name: "Education" },
        { type: "CHILDP", name: "Protection de l'enfants" },
        { type: "ENVIRO", name: "Eau, assainissement et hygiène" },
        { type: "SOCIAL", name: "Politique sociale" },
        { type: "CIVILR", name: "Participation et droits civils" },
    ];
    const { data, setData, errors, put, processing } = (0, inertia_react_1.useForm)({
        name: imageModel.name,
        category: imageModel.category,
    });
    function handleSubmit(e) {
        e.preventDefault();
        put((0, ziggy_js_1.default)("images.update", imageModel.id));
    }
    function destroy() {
        if (confirm("Are you sure you want to delete this contact?")) {
            inertia_1.Inertia.delete((0, ziggy_js_1.default)("images.destroy", imageModel.id));
        }
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(FlashMessages_1.default, null),
        react_1.default.createElement("h1", { className: "mb-8 text-3xl font-bold" },
            react_1.default.createElement(inertia_react_1.InertiaLink, { href: (0, ziggy_js_1.default)("images.index"), className: "text-[#004e81]  hover:text-[#113953]" }, "Images"),
            react_1.default.createElement("span", { className: "font-medium text-[#004e81] " }, " /"),
            " \u00C9diter"),
        react_1.default.createElement("div", { className: "max-w-3xl overflow-hidden bg-white rounded shadow" },
            react_1.default.createElement("form", { onSubmit: handleSubmit },
                react_1.default.createElement("div", { className: "flex flex-wrap p-8 -mb-8 -mr-6" },
                    react_1.default.createElement(TextInput_1.default, { className: "w-full pb-8 pr-6 lg:w-1/2", label: "Nom", name: "name", errors: errors.name, value: data.name, onChange: (e) => setData("name", e.target.value) }),
                    react_1.default.createElement(SelectInput_1.default, { className: "w-full pb-8 pr-6 lg:w-1/2", label: "Cat\u00E9gorie", name: "category", errors: errors.category, value: data.category, onChange: (e) => setData("category", e.target.value) }, categorys.map(({ type, name }) => (react_1.default.createElement("option", { key: type, value: type }, name)))),
                    react_1.default.createElement("div", { className: "w-full pb-8 pr-6" }, imageModel.image != null ? (react_1.default.createElement("img", { src: ("/" + imageModel.image), alt: "image" })) : undefined)),
                react_1.default.createElement("div", { className: "flex items-center px-8 py-4 bg-gray-100 border-t border-gray-200" },
                    react_1.default.createElement(DeleteButton_1.default, { onDelete: destroy }, "Supprimer l'image"),
                    react_1.default.createElement(LoadingButton_1.default, { loading: processing, type: "submit", className: "ml-auto btn-indigo" }, "\u00C9diter l'image"))))));
};
Edit.layout = (page) => react_1.default.createElement(Layout_1.default, { title: "Add Image", children: page });
exports.default = Edit;
